/* __next_internal_client_entry_do_not_use__ VerticalEllipsis auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=2869%3A793))
 * @trackcomponent
 * @donotsync Syncing adds default color (@quinlan.sokol)
 */ export var VerticalEllipsis = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M12.0001 23.1429C13.4203 23.1429 14.5716 21.9916 14.5716 20.5714C14.5716 19.1513 13.4203 18 12.0001 18C10.58 18 9.42871 19.1513 9.42871 20.5714C9.42871 21.9916 10.58 23.1429 12.0001 23.1429Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M12.0001 14.5725C13.4203 14.5725 14.5716 13.4213 14.5716 12.0011C14.5716 10.581 13.4203 9.42969 12.0001 9.42969C10.58 9.42969 9.42871 10.581 9.42871 12.0011C9.42871 13.4213 10.58 14.5725 12.0001 14.5725Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M12.0001 6.00028C13.4203 6.00028 14.5716 4.84901 14.5716 3.42885C14.5716 2.00869 13.4203 0.857422 12.0001 0.857422C10.58 0.857422 9.42871 2.00869 9.42871 3.42885C9.42871 4.84901 10.58 6.00028 12.0001 6.00028Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "VerticalEllipsis", function(strictLocalize) {
    return {
        viewBox: "0 0 24 24",
        titleAccess: strictLocalize({
            id: "3tTkSB",
            defaultMessage: [
                {
                    type: 0,
                    value: "More options"
                }
            ]
        }),
        fill: "none"
    };
});
